var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBagOpenD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.25H18V4.375C18 4.20929 17.9341 4.05029 17.8169 3.93311C17.6997 3.81592 17.5408 3.75 17.375 3.75H3.625C3.45924 3.75 3.30026 3.81592 3.18306 3.93311C3.06585 4.05029 3 4.20929 3 4.375V6.25Z",
    fill: "#1C1C1C",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 4.375C2.375 4.375 2.375 3.85723 2.74112 3.49112C2.74112 3.49112 3.10723 3.125 3.625 3.125H17.375C17.375 3.125 17.8928 3.125 18.2589 3.49112C18.2589 3.49112 18.625 3.85723 18.625 4.375V15.625C18.625 15.625 18.625 16.1428 18.2589 16.5089C18.2589 16.5089 17.8928 16.875 17.375 16.875H3.625C3.625 16.875 3.10723 16.875 2.74112 16.5089C2.74112 16.5089 2.375 16.1428 2.375 15.625V4.375ZM3.625 4.375V15.625H17.375V4.375H3.625Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.875H18C18.3452 6.875 18.625 6.59518 18.625 6.25C18.625 5.90482 18.3452 5.625 18 5.625H3C2.65482 5.625 2.375 5.90482 2.375 6.25C2.375 6.59518 2.65482 6.875 3 6.875Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73223 10.5178C8 9.78553 8 8.75 8 8.75C8 8.40482 7.72018 8.125 7.375 8.125C7.02982 8.125 6.75 8.40482 6.75 8.75C6.75 10.3033 7.84835 11.4017 7.84835 11.4017C8.9467 12.5 10.5 12.5 10.5 12.5C12.0533 12.5 13.1517 11.4017 13.1517 11.4017C14.25 10.3033 14.25 8.75 14.25 8.75C14.25 8.40482 13.9702 8.125 13.625 8.125C13.2798 8.125 13 8.40482 13 8.75C13 9.78553 12.2678 10.5178 12.2678 10.5178C11.5355 11.25 10.5 11.25 10.5 11.25C9.46447 11.25 8.73223 10.5178 8.73223 10.5178Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagOpenD);
export default __webpack_public_path__ + "static/media/ShoppingBagOpen-d.2d6c79f2e66e5ba0c9ee5bdc96f79c0c.svg";
export { ForwardRef as ReactComponent };